$(window).on('load', function() {
  const swiper = new Swiper('.swiper-nature-items', {
    slidesPerView: "auto",
    spaceBetween: 24,
    pagination: {
      el: "#swiper-nature-items-swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: '#swiper-nature-items-button-next',
      prevEl: '#swiper-nature-items-button-prev',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    observer: true,
    observeParents: true,
    breakpoints: {
      1280: { spaceBetween: 24 },
      992:  { spaceBetween: 24 },
      768:  { spaceBetween: 16 },
      576:  {},
      0:    { spaceBetween: 16 },
    },
  });
});


//  $(document).ready(function(){
//     const swiper = new Swiper('.swiper-nature-items', {
//       slidesPerView: "auto",
//       spaceBetween: 24,
//       pagination: {
//         el: "#swiper-nature-items-swiper-pagination",
//         type: "progressbar",
//       },
//       navigation: {
//         nextEl: '#swiper-nature-items-button-next',
//         prevEl: '#swiper-nature-items-button-prev',
//       },
//       mousewheel: {
//         enabled: true,
//         forceToAxis: true,
//       },
//       breakpoints: {
//         1280: {
//           // slidesPerView: 4.6,
//           spaceBetween: 24,
//         },
//         992: {
//           // slidesPerView: 3.6,
//           spaceBetween: 24,
//         },
//         768: {
//           // slidesPerView: 2.5,
//           spaceBetween: 16,
//         },
//         576: {
//           // slidesPerView: 2.2,
//         },
//         0: {
//           // slidesPerView: 1.2,
//         spaceBetween: 16,
//         },
//       },
//     });
// })

//  $(document).ready(function(){
//     const swiper = new Swiper('.swiper-multicolumn-items', {
//       slidesPerView: 1.6,
//       spaceBetween: 24,
//       pagination: {
//         el: "#swiper-multicolumn-items-swiper-pagination",
//         type: "progressbar",
//       },
//       navigation: {
//         nextEl: '#swiper-multicolumn-items-button-next',
//         prevEl: '#swiper-multicolumn-items-button-prev',
//       },
//       breakpoints: {
//         992: {
//           slidesPerView: 1.6,
//           spaceBetween: 24,
//         },
//         768: {
//           slidesPerView: 1.5,
//           spaceBetween: 16,
//         },
//         576: {
//           slidesPerView: 1.3,
//         },
//         0: {
//           slidesPerView: 1.2,
//         spaceBetween: 16,
//         },
//       },
//     });
// })